import React from 'react';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import MuiContainer from '@material-ui/core/Container';
import { NextSeo } from 'next-seo';

const Container = styled(MuiContainer)`
  display: flex !important;
  flex-direction: column;
`;

const DisclaimerPolicy = () => {
  return (
    <>
      <NextSeo
        title="Disclaimer Policy"
        description="If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at info@rentable.pk"
        canonical="https://rentable.pk/disclaimer-policy"
        openGraph={{
          url: 'https://rentable.pk/disclaimer-policy',
          type: 'basic',
          title: 'Disclaimer Policy',
          description:
            'If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at info@rentable.pk',
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      <Container maxWidth="lg">
        <Typography style={{ marginTop: 30 }} variant="h3" color="primary">
          Disclaimer Policy
        </Typography>
        <Typography variant="subtitle1">
          <em>Last updated on 25 December, 2019</em>
        </Typography>

        <Typography variant="body1" style={{ marginTop: 30 }}>
          <p>
            If you require any more information or have any questions about our site’s disclaimer,
            please feel free to contact us by email at info@rentable.pk
          </p>
          <p>
            All the information on this website is published in good faith and for general
            information purpose only. https://rentable.pk/ does not make any warranties about the
            completeness, reliability and accuracy of this information. Any action you take upon the
            information you find on this website (https://rentable.pk/), is strictly at your own
            risk. https://thewebtier.com/ will not be liable for any losses and/or damages in
            connection with the use of our website.
          </p>
          <p>
            From our website, you can visit other websites by following hyperlinks to such external
            sites. While we strive to provide only quality links to useful and ethical websites, we
            have no control over the content and nature of these sites. These links to other
            websites do not imply a recommendation for all the content found on these sites. Site
            owners and content may change without notice and may occur before we have the
            opportunity to remove a link which may have gone ‘bad’.
          </p>
          <p>
            Please be also aware that when you leave our website, other sites may have different
            privacy policies and terms which are beyond our control. Please be sure to check the
            Privacy Policies of these sites as well as their “Terms of Service” before engaging in
            any business or uploading any information.
          </p>
        </Typography>
        <Typography variant="h4">Consent</Typography>
        <Typography variant="body1">
          <p>By using our website, you hereby consent to our disclaimer and agree to its terms.</p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Update
        </Typography>
        <Typography variant="body1" style={{ marginBottom: 40 }}>
          <p>
            Should we update, amend or make any changes to this document, those changes will be
            prominently posted here.
          </p>
        </Typography>
      </Container>
    </>
  );
};

export default DisclaimerPolicy;
